__turbopack_context__.v({
  "availability": "auth-module__uh9QMa__availability",
  "available": "auth-module__uh9QMa__available",
  "brand": "auth-module__uh9QMa__brand",
  "card": "auth-module__uh9QMa__card",
  "divider": "auth-module__uh9QMa__divider",
  "error": "auth-module__uh9QMa__error",
  "eyebrow": "auth-module__uh9QMa__eyebrow",
  "fieldHint": "auth-module__uh9QMa__fieldHint",
  "form": "auth-module__uh9QMa__form",
  "google": "auth-module__uh9QMa__google",
  "lead": "auth-module__uh9QMa__lead",
  "note": "auth-module__uh9QMa__note",
  "page": "auth-module__uh9QMa__page",
  "submit": "auth-module__uh9QMa__submit",
  "switch": "auth-module__uh9QMa__switch",
});
